module.exports = __webpack_public_path__ + "img/favicon.66e83ba8.png";